module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/aoj_d-4-7f8784acd6cc2373e48c91cf3f11c701.jpg";